import { Model } from 'modules/core/lib/mobx-rest'

import type { ITemplateVariable } from './Variable'

class FieldVariable extends Model<ITemplateVariable> {
  static urlRoot() {
    return '/field_variables'
  }
}

export default FieldVariable
